import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/dashboard?${query}`)
  }
}

export default DashboardService
